import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const ContactInfoSection = () => {
  return (
    <>
      <style>{`
        :root {
          --contact-accent: #7ac142;
          --contact-bg: #ffffff;
          --contact-text: #111827;
          --contact-muted: #6b7280;
          --contact-shadow: 0 18px 50px rgba(0,0,0,0.08);
          --contact-radius: 20px;
        }

        .contact-area {
          padding: 0px 0 40px;
          background: var(--contact-bg);
        }

        .contact-title {
          font-size: 40px;
          font-weight: 800;
          margin-bottom: 60px;
          color: var(--contact-text);
        }

        .contact-feature {
          position: relative;
          background: #ffffff;
          border-radius: var(--contact-radius);
          padding: 42px 34px;
          box-shadow: var(--contact-shadow);
          display: flex;
          align-items: flex-start;
          gap: 18px;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          overflow: hidden;
        }

        .contact-feature:hover {
          transform: translateY(-8px);
          box-shadow: 0 30px 70px rgba(0,0,0,0.15);
        }

        .feature-contact-icon {
          position: absolute;
          top: 18px;
          right: 18px;
          width: 70px;
          opacity: 0.08;
          pointer-events: none;
        }

        .contact-feature-icon {
          width: 54px;
          height: 54px;
          min-width: 54px;
          border-radius: 50%;
          background: var(--contact-accent);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 22px;
        }

        .contact-feature-label {
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 6px;
          color: var(--contact-text);
        }

        .contact-feature-link {
          display: block;
          font-size: 15px;
          color: var(--contact-muted);
          line-height: 1.6;
          text-decoration: none;
        }

        .contact-feature-link:hover {
          color: var(--contact-accent);
        }

        @media (max-width: 900px) {
          .contact-title {
            font-size: 32px;
            margin-bottom: 40px;
          }
        }

        @media (max-width: 600px) {
          .contact-area {
            padding: 70px 0 20px;
          }
        }
      `}</style>

      <Box component="section" className="contact-area" id="contact-sec">
        <Container>
          <Box textAlign="center">
            <Typography component="h2" className="contact-title">
              Our Contact Information
            </Typography>
          </Box>

          <Grid container spacing={4} justifyContent="center">
            {/* ADDRESS */}
            <Grid item xs={12} md={6} xl={4}>
              <Box className="contact-feature">
                <img
                  src="https://html.themehour.net/kleanix/demo/assets/img/icon/feature-contact-icon.png"
                  alt=""
                  className="feature-contact-icon"
                />

                <Box className="contact-feature-icon">
                  <LocationOnIcon />
                </Box>

                <Box>
                  <Typography className="contact-feature-label">
                    Our Address
                  </Typography>
                  <MuiLink
                    href="https://www.google.com/maps"
                    target="_blank"
                    className="contact-feature-link"
                  >
                    4321 E 3rd St, <br />
                    Bloomington, IN 47401
                  </MuiLink>
                </Box>
              </Box>
            </Grid>

            {/* CONTACT */}
            <Grid item xs={12} md={6} xl={4}>
              <Box className="contact-feature">
                <img
                  src="https://html.themehour.net/kleanix/demo/assets/img/icon/feature-contact-icon.png"
                  alt=""
                  className="feature-contact-icon"
                />

                <Box className="contact-feature-icon">
                  <PhoneIcon />
                </Box>

                <Box>
                  <Typography className="contact-feature-label">
                    Contact Number
                  </Typography>
                  <MuiLink
                    href="tel:+17188728472"
                    className="contact-feature-link"
                  >
                    Mobile: +1 (718) 872-8472
                  </MuiLink>
                  <MuiLink
                    href="mailto:info@ritehomepros.com"
                    className="contact-feature-link"
                  >
                    Email: info@ritehomepros.com
                  </MuiLink>
                </Box>
              </Box>
            </Grid>

            {/* HOURS */}
            <Grid item xs={12} md={6} xl={4}>
              <Box className="contact-feature">
                <img
                  src="https://html.themehour.net/kleanix/demo/assets/img/icon/feature-contact-icon.png"
                  alt=""
                  className="feature-contact-icon"
                />

                <Box className="contact-feature-icon">
                  <AccessTimeIcon />
                </Box>

                <Box>
                  <Typography className="contact-feature-label">
                    Opening Hour
                  </Typography>
                  <Typography className="contact-feature-link">
                    24 × 7 Open
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ContactInfoSection;
